export default __webpack_public_path__ + "static/media/grafema_ummi_03.3e4d9634.jpg";